import React from 'react'

function Designs() {
  return (
    <div>Designs</div>
  )
}

export default Designs